import { toast } from "react-toastify";
import {
  DRIVER_ADD_SUCCESS,
  DRIVER_ADD_REQUEST,
  DRIVER_ADD_FAIL,
  //
  DRIVER_LIST_SUCCESS,
  DRIVER_LIST_REQUEST,
  DRIVER_LIST_FAIL,
  //
  DRIVER_DETAIL_SUCCESS,
  DRIVER_DETAIL_REQUEST,
  DRIVER_DETAIL_FAIL,
  //
  DRIVER_DELETE_SUCCESS,
  DRIVER_DELETE_REQUEST,
  DRIVER_DELETE_FAIL,
  //
  DRIVER_UPDATE_SUCCESS,
  DRIVER_UPDATE_REQUEST,
  DRIVER_UPDATE_FAIL,
  //

  //
} from "../constants/driverConstants";

export const deleteDriverReducer = (state = {}, action) => {
  switch (action.type) {
    case DRIVER_DELETE_REQUEST:
      return { loadingDriverDelete: true };
    case DRIVER_DELETE_SUCCESS:
      toast.success("This Driver has been successfully deleted.");
      return {
        loadingDriverDelete: false,
        successDriverDelete: true,
      };
    case DRIVER_DELETE_FAIL:
      return {
        loadingDriverDelete: false,
        errorDriverDelete: action.payload,
        successDriverDelete: false,
      };
    default:
      return state;
  }
};

export const updateDriverReducer = (state = {}, action) => {
  switch (action.type) {
    case DRIVER_UPDATE_REQUEST:
      return { loadingDriverUpdate: true };
    case DRIVER_UPDATE_SUCCESS:
      toast.success("This Driver has been successfully updated");
      return {
        loadingDriverUpdate: false,
        successDriverUpdate: true,
      };
    case DRIVER_UPDATE_FAIL:
      return {
        loadingDriverUpdate: false,
        errorDriverUpdate: action.payload,
        successDriverUpdate: false,
      };
    default:
      return state;
  }
};

export const detailDriverReducer = (state = { driverInfo: {} }, action) => {
  switch (action.type) {
    case DRIVER_DETAIL_REQUEST:
      return { loadingDriverInfo: true };
    case DRIVER_DETAIL_SUCCESS:
      return {
        loadingDriverInfo: false,
        successDriverInfo: true,
        driverInfo: action.payload.user,
      };
    case DRIVER_DETAIL_FAIL:
      return {
        loadingDriverInfo: false,
        successDriverInfo: false,
        errorDriverInfo: action.payload,
      };
    default:
      return state;
  }
};

export const createNewDriverReducer = (state = {}, action) => {
  switch (action.type) {
    case DRIVER_ADD_REQUEST:
      return { loadingDriverAdd: true };
    case DRIVER_ADD_SUCCESS:
      toast.success("This Driver has been added successfully");
      return {
        loadingDriverAdd: false,
        successDriverAdd: true,
      };
    case DRIVER_ADD_FAIL:
      toast.error(action.payload);
      return {
        loadingDriverAdd: false,
        successDriverAdd: false,
        errorDriverAdd: action.payload,
      };
    default:
      return state;
  }
};

export const getListDriversReducer = (state = { drivers: [] }, action) => {
  switch (action.type) {
    case DRIVER_LIST_REQUEST:
      return { loadingListDrivers: true, drivers: [] };
    case DRIVER_LIST_SUCCESS:
      return {
        loadingListDrivers: false,
        drivers: action.payload.users,
        pages: action.payload.pages,
        page: action.payload.page,
      };
    case DRIVER_LIST_FAIL:
      return {
        loadingListDrivers: false,
        errorListDrivers: action.payload,
      };
    default:
      return state;
  }
};
